import httpClient from '@/api/http-client';

const endpoint = 'api/subjects';

const subjectsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (subject) => httpClient.post(`${endpoint}`, subject),

  update: (subject) => httpClient.put(`${endpoint}/${subject.id}`, subject),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  delete: (subject) => httpClient.delete(`${endpoint}/${subject.id}`),

  restore: (subject) => httpClient.get(`${endpoint}/${subject.id}/restore`)
};

export default subjectsService;
